import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import "../../App.css";

function Navbar() {
  const [navActive, setNavActive] = useState(false);
  const [showExtraItems, setShowExtraItems] = useState(true);

  const location = useLocation();

  const toggleNav = () => {
    setNavActive(!navActive);
  };

  const closeMenu = () => {
    setNavActive(false);
  };

  const handleHomeClick = () => {
    setShowExtraItems(true);
    closeMenu();
  };

  const handleOtherLinkClick = () => {
    setShowExtraItems(false);
    closeMenu();
  };

  useEffect(() => {
    const hiddenRoutes = [
      "/experience",
      "/expertise",
      "/all-projects",
      "/my-journey",
      "/qualification",
    ];

    if (hiddenRoutes.includes(location.pathname)) {
      setShowExtraItems(false);
    } else {
      setShowExtraItems(true);
    }
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) {
        closeMenu();
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <nav
      className={`navbar text-sm responsive-text ${navActive ? "active" : ""}`}
    >
      <div className="navimage">
        {/* <img src="./img/mylogo.png" alt="Logoipsum" className="h-8" /> */}
      </div>
      <a
        className={`nav__hamburger ${navActive ? "active" : ""}`}
        onClick={toggleNav}
      >
        <span className="nav__hamburger__line"></span>
        <span className="nav__hamburger__line"></span>
        <span className="nav__hamburger__line"></span>
      </a>
      <div className={`navbar--items ${navActive ? "active" : ""}`}>
        <ul className="responsive-text">
          <li>
            <NavLink
              onClick={handleHomeClick}
              to="/"
              className={({ isActive }) =>
                isActive
                  ? "navbar--active-content responsive-text"
                  : "navbar--content responsive-text"
              }
            >
              Home
            </NavLink>
          </li>
          {showExtraItems && (
            <>
              <li>
                <ScrollLink
                  onClick={closeMenu}
                  to="MyPortfolio"
                  className="navbar--content responsive-text"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Portfolio
                </ScrollLink>
              </li>
              <li>
                <ScrollLink
                  onClick={closeMenu}
                  to="AboutMe"
                  className="navbar--content responsive-text"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  About Me
                </ScrollLink>
              </li>
              <li>
                <ScrollLink
                  onClick={closeMenu}
                  to="testimonial"
                  className="navbar--content responsive-text"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Skills
                </ScrollLink>
              </li>
            </>
          )}
          <li>
            <NavLink
              onClick={handleOtherLinkClick}
              to="/experience"
              className={({ isActive }) =>
                isActive
                  ? "navbar--active-content responsive-text"
                  : "navbar--content responsive-text"
              }
            >
              Experience
            </NavLink>
          </li>
          <li>
            <NavLink
              onClick={handleOtherLinkClick}
              to="/expertise"
              className={({ isActive }) =>
                isActive
                  ? "navbar--active-content responsive-text"
                  : "navbar--content responsive-text"
              }
            >
              Expertise
            </NavLink>
          </li>
          <li>
            <NavLink
              onClick={handleOtherLinkClick}
              to="/all-projects"
              className={({ isActive }) =>
                isActive
                  ? "navbar--active-content responsive-text"
                  : "navbar--content responsive-text"
              }
            >
              All Projects
            </NavLink>
          </li>
          <li>
            <NavLink
              onClick={handleOtherLinkClick}
              to="/my-journey"
              className={({ isActive }) =>
                isActive
                  ? "navbar--active-content responsive-text"
                  : "navbar--content responsive-text"
              }
            >
              My Journey
            </NavLink>
          </li>
          <li>
            <NavLink
              onClick={handleOtherLinkClick}
              to="/qualification"
              className={({ isActive }) =>
                isActive
                  ? "navbar--active-content responsive-text"
                  : "navbar--content responsive-text"
              }
            >
              My Qualifications & Certificates
            </NavLink>
          </li>
        </ul>
      </div>
      {showExtraItems ? (
        <ScrollLink
          onClick={closeMenu}
          to="Contact"
          className="btn btn-outline-primary responsive-text"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
        >
          Contact Me
        </ScrollLink>
      ) : (
        <div className="contact-info responsive-text">
          <p>{/* Contact info commented out */}</p>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
